import React from "react";
import { themeStyles } from "../styles/globalColors";

interface Props {
  tabs: string[];
  selectedTabIndex: number;
  onChangeTabIndex: (p_index: number) => void;
}

function TabsComponent(props: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderBottom: "0.8px solid lightgray",
        ...themeStyles.borderColor,
        padding: 0.2,
      }}
    >
      {props.tabs.map((tab, index) => (
        <div
          onClick={() => props.onChangeTabIndex(index)}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 10,
            borderBottom:
              props.selectedTabIndex === index ? `2px solid ${themeStyles.fontColorMain.color}` : undefined,
          }}
        >
          <div
            style={{
              fontWeight: props.selectedTabIndex === index ? "bold" : "normal",
              ...themeStyles.fontColorMain
            }}
          >
            {tab}
          </div>
        </div>
      ))}
    </div>
  );
}

export default TabsComponent;
